export default "__VITE_ASSET__BZ6J6Vpo__"